export * from "./trip-status.component";
